import { TestRoutineEntrySchema } from '#app/routes/mocra+/_form+/components/test-routines/schema.ts'
import {
	collectTestRoutineErrors,
	createTestRoutineDraft,
	sanitizeTestRoutineDraft,
	testRoutineDraftToEntry,
	testRoutineEntryToDraft,
	type TestRoutineDraft,
} from '#app/routes/mocra+/_form+/components/test-routines/types.ts'
import { assertEntityDefinition } from '#app/routes/mocra+/_form+/entity-definition.ts'

export const testRoutineDefinition = assertEntityDefinition({
	schema: TestRoutineEntrySchema,
	createDraft: () => createTestRoutineDraft(),
	sanitizeDraft: sanitizeTestRoutineDraft,
	serialize: testRoutineDraftToEntry,
	deserialize: testRoutineEntryToDraft,
	collectErrors: collectTestRoutineErrors,
})

export type TestRoutineEntityDraft = TestRoutineDraft
